module.exports = __webpack_public_path__ + "static/media/tn.c3deb641.svg";